import {types} from './types';

const setGetUsersAction = (payload) => {
    return {
        type: types.SET_USERS_LIST,
        payload,
      }
}

const setGetUserAction = (payload) => {
  return {
      type: types.SET_USER_BY_ID,
      payload,
    }
}

const setGetWithdrawalsUserAction = (payload) => {
  return {
    type: types.SET_WITHDRAWALS_USER,
    payload,
  }
}

const setGetReplenishmentUserAction = (payload) => {
  return {
    type: types.SET_REPLENISHMENT_USER,
    payload
  }
}

const setGetHistoryGamesUserAction = (payload) => {
  return {
    type: types.SET_HISTORY_GAMES_USER,
    payload
  }
}

const setGetHistoryBonusGetByIdAction = (payload) => {
  return {
    type: types.SET_BONUSES_HISTORY,
    payload
  }
}

const setGetLastOperationAction = (payload) => {
  return {
    type: types.SET_LAST_OPERATION,
    payload
  }
}

const setGetRezymeAction = (payload) => {
  return {
    type: types.SET_REZYME,
    payload
  }
}

const setGetBetAction = (payload) => {
  return {
    type: types.SET_BET,
    payload
  }
}


const setGetVerificationAction = (payload) => {
  return {
    type: types.SET_VERIFICATION,
    payload
  }
}

const setGetJackpotHistoryListAction = (payload) => {
  return {
      type: types.SET_HISTORY_LIST,
      payload,
    }
}

const setGetFreespinOperationAction = (payload) => {
  return {
    type: types.SET_FREESPIN_OPERATION,
    payload
  }
}

const setGetUserLoggerAction = (payload) => {
  return {
    type: types.SET_USER_LOGGER,
    payload
  }
}

const setGetGamesListFsAction = (payload) => {
  return {
    type: types.SET_GAMES_LIST,
    payload
  }
}

const setGetTagsAction = (payload) => {
  return {
    type: types.SET_GET_TAGS,
    payload
  }
}

export {
  setGetUsersAction,
  setGetUserAction,
  setGetWithdrawalsUserAction,
  setGetReplenishmentUserAction,
  setGetHistoryGamesUserAction,
  setGetHistoryBonusGetByIdAction,
  setGetLastOperationAction,
  setGetRezymeAction,
  setGetVerificationAction,
  setGetJackpotHistoryListAction,
  setGetFreespinOperationAction,
  setGetUserLoggerAction,
  setGetGamesListFsAction,
  setGetBetAction,
  setGetTagsAction
}